module.exports = require('./helpers/bundle-url').getBundleURL('f7fK2') + "logo.c51670a8.svg";